import Swal from "sweetalert2";

export const ThemedSwal = Swal.mixin({
  background: "#15121c",
  color: "#ffffff",
  confirmButtonColor: "#0d6efd",
  customClass: {
    popup: "aicharge-swal-popup",
  },
});
